<template>
    <div class="template-with-mobile">
        <div :class="`mobile step-${ appStep }`">
            <div class="width">
                <figure class="frame">
                    <img src="/imgs/web/webdemo-doctors/mobile_frame.webp">
                </figure>
    
                <figure class="screen">
                    <picture>
                        <source media="(min-width: 1800px)" :src="`/imgs/web/webdemo-doctors/app_step_screen_${ appStep }@2x.webp`">
                        <img :src="`/imgs/web/webdemo-doctors/app_step_screen_${ appStep }.webp`" :srcset="`/imgs/web/webdemo-doctors/app_step_screen_${ appStep }.webp 1x, /imgs/web/webdemo-doctors/app_step_screen_${ appStep }@2x.webp 2x`">                   
                    </picture>
                </figure>

                <figure v-if="appStep == 10 || appStep == 13" class="second-btn">
                    <img :src="`/imgs/web/webdemo-doctors/app_step_btn_${ appStep }_second@2x.webp`">
                </figure>
    
                <a class="btn-next" @click="nextStep()">
                    <figure>
                        <img v-if="!weiterBtn" :src="`/imgs/web/webdemo-doctors/app_step_btn_${ appStep }@2x.webp`">
                        <img v-else src="/imgs/web/webdemo-doctors/app_step_btn_5@2x.webp">
                    </figure>
                </a>
            </div>
        </div>
        <figure class="shadow">
            <picture>
                <img src="/imgs/web/webdemo-doctors/shadow_bottom.webp" srcset="/imgs/web/webdemo-doctors/shadow_bottom.webp 1x, /imgs/web/webdemo-doctors/shadow_bottom@2x.webp 2x">
            </picture>
        </figure>
    </div>
</template>

<script>
export default {
    props: {
        appStep: {
            type: Number,
            required: true,
        },

        weiterBtn: {
            type: Boolean,
            default: false
        }
    },

    mounted() {
        const bcg = document.querySelector(".frame")
        const btn = document.querySelector(".btn-next")
        const secondBtn = document.querySelector(".second-btn")

        setTimeout(() => {
            bcg.classList.add('bcg-active')
            btn.classList.add('active')

            if (secondBtn) {                
                secondBtn.classList.add('active')
            }
        }, 2000);
    },

    methods: {
        nextStep() {
            this.$emit('app-step-from-mobile-template')
        },
    }
}

</script>

